import React from 'react';

import Button from '@/components/Button';
import { FormContext } from '@/components/Form/provider';
import LocaleText from '@/components/Intl/LocaleText';
import { ECustomerSkinProblem } from '@/helpers/API/requests/interfaces/customer';

import Layout from './Layout';
import { TPersonalizationStepForm } from './interfaces';
import Styles from './styles.module.scss';

const HealthTarget: React.FC<TPersonalizationStepForm> = ({ formRef }) => {
    const formContext = React.useContext(FormContext);
    const [selected, setSelected] = React.useState<ECustomerSkinProblem[]>([]);

    React.useEffect(function syncProblemsToFormContext() {
        formContext.datas['problems'] = selected;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    React.useEffect(function cleanupProblemsOnUnmount() {
        return () => {
            delete formContext.datas['problems'];
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggle = (value: ECustomerSkinProblem): void => {
        setSelected((prev) => {
            if (prev.includes(value)) return prev.filter((v) => v !== value);
            if (prev.length >= 2) return prev;
            return [...prev, value];
        });
    };

    return (
        <Layout title='form.personalizationStep.healthTarget.title' subtitle='form.personalizationStep.healthTarget.subtitle'>
            {Object.values(ECustomerSkinProblem).map((value) => {
                const isSelected = selected.includes(value);
                return (
                    <div key={value} className={Styles.personnalisationStep__multiOption}>
                        <label
                            className={`${Styles.personnalisationStep__multiOption__button} ${
                                isSelected
                                    ? Styles['personnalisationStep__multiOption__button--selected']
                                    : ''
                            }`}
                        >
                            <input
                                type='checkbox'
                                className={Styles.personnalisationStep__multiOption__input}
                                checked={isSelected}
                                disabled={!isSelected && selected.length >= 2}
                                onChange={() => toggle(value)}
                            />
                            <LocaleText>{'form.personalizationStep.radio.' + value}</LocaleText>
                        </label>
                    </div>
                );
            })}
            <Button
                type='button'
                disabled={selected.length === 0}
                className={Styles.submitButton}
                onClick={() => formRef.current!.next()}
            >
                <LocaleText>form.personalizationStep.healthTarget.submit</LocaleText>
            </Button>
        </Layout>
    );
};

export default HealthTarget;
